<template>
  <div
    v-if="show"
    id="form_btn_container"
    class="text-[var(--text)] min-w-[40%] gap-2 p-4 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col fixed-half"
  >
    <div class="w-full flex justify-between">
      <h3 class="text-[var(--titulo)] text-[18px] font-bold">{{ form_title }}</h3>
      <div class="flex items-center gap-2">
        <HistoricoObjetoButton
          model-name="Sucursal"
          :objeto-id="form_data.id"
          modelo-label="Sucursal"
          variant="bare"
          icon-only
        />
        <AppButton
          style="color: var(--icon)"
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="23"
          :height="23"
        />
      </div>
    </div>

    <div class="form_container">
      <div id="left_form" class="left_form">
        <div class="grid grid-cols-[auto_1fr] gap-2 mr-6">
          <div class="flex gap-2 items-center">
            <label for="sucursal" class="min-w-[55px] font-bold">Sucursal:</label>
          </div>
          <div class="flex gap-2 items-center">
            <textarea
              :disabled="form_data.status == 'desativado'"
              type="text"
              v-model="formData.sucursal"
              placeholder="Nome da sucursal"
              maxlength="400"
              class="w-full text-[20px] p-1 rounded-[5px]"
              :class="{ 'input-required': !formData.sucursal }"
            ></textarea>
          </div>
        </div>

        <div class="data_set_class">
          <div class="grid grid-cols-[auto_1fr_min-content] gap-y-1 mr-6 items-center">
            <div class="ser_data">
              <label class="min-w-[76px] font-bold">Zona:</label>
            </div>
            <div
              class="ser_data"
              :style="{ color: (set_data.zona?.id || 0) === 0 ? 'var(--obrigatorio)' : 'var(--icon)' }"
            >
              {{ set_data.zona?.nome || "Não Atribuído" }}
            </div>
            <div class="ser_data w-[4px]">
              <button
                :style="iconStyle()"
                :disabled="form_data.status == 'desativado'"
                @click="selectTable('zona')"
              >
                <Icon class="edit-icon" icon="lucide:map-pinned" />
              </button>
            </div>

            <div class="ser_data">
              <label class="min-w-[76px] font-bold">Morada:</label>
            </div>
            <div class="ser_data" style="color: var(--icon)">
              {{ moradaResumida }}
            </div>
            <div class="ser_data w-[4px]">
              <button
                :style="iconStyle()"
                :disabled="form_data.status == 'desativado'"
                @click="selectTable('mapa')"
              >
                <Icon class="edit-icon" icon="lucide:map" />
              </button>
            </div>
          </div>
        </div>

        <div class="data_set_class">
          <div class="grid grid-cols-[auto_1fr] gap-y-1 gap-x-2 mr-6 items-center">
            <div class="ser_data">
              <label for="objetivo_premio" class="min-w-[76px] font-bold">Obj. Prémio (€/mês):</label>
            </div>
            <input
              id="objetivo_premio"
              type="number"
              min="0"
              step="0.01"
              :disabled="form_data.status == 'desativado'"
              v-model.number="formData.objetivo_premio"
              class="w-full p-1 rounded-[5px]"
            />

            <div class="ser_data">
              <label for="objetivo_financeiro" class="min-w-[76px] font-bold">Obj. Financeiro (€/mês):</label>
            </div>
            <input
              id="objetivo_financeiro"
              type="number"
              min="0"
              step="0.01"
              :disabled="form_data.status == 'desativado'"
              v-model.number="formData.objetivo_financeiro"
              class="w-full p-1 rounded-[5px]"
            />
          </div>
        </div>
      </div>
    </div>

    <div style="display: flex; gap: 0.5rem; padding: 1rem">
      <button
        v-if="create_btn && validPermission('SU0003')"
        class="btn"
        @click="showConfirm($event, 'create')"
      >
        Criar
      </button>
      <button
        v-if="!create_btn && validPermission('SU0003') && form_data.status == 'ativo'"
        class="btn"
        @click="showConfirm($event, 'update')"
      >
        Atualizar
      </button>
      <button
        v-if="!create_btn && validPermission('SU0003') && form_data.status == 'ativo'"
        class="btn"
        :style="{ backgroundColor: 'red' }"
        @click="showConfirm($event, 'disable')"
      >
        Desativar
      </button>
      <button
        v-if="!create_btn && validPermission('SU0003') && form_data.status == 'desativado'"
        class="btn"
        :style="{ backgroundColor: 'green' }"
        @click="showConfirm($event, 'disable')"
      >
        Ativar
      </button>
      <button
        v-if="!create_btn && validPermission('SU0003')"
        class="btn"
        :style="{ backgroundColor: 'var(--desativado)' }"
        @click="showConfirm($event, 'remove')"
      >
        Eliminar
      </button>

      <ConfirmPopUp ref="myConfirm" @accept="onAccept" />
    </div>
  </div>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import { toast } from "vue3-toastify";
import permissionMixin from "@/permissionMixin.js";
import HistoricoObjetoButton from "@/components/historico/HistoricoObjetoButton.vue";

export default {
  mixins: [permissionMixin],
  name: "AppSucursalForm",
  components: {
    AppButton,
    ConfirmPopUp,
    HistoricoObjetoButton,
  },
  props: {
    form_data: {
      type: Object,
      default: () => ({}),
    },
    set_data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    form_title: {
      type: String,
      default: () => "No Title",
    },
    create_btn: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      formData: {},
      emit_type: "",
    };
  },
  computed: {
    moradaResumida() {
      const endereco = this.set_data?.endereco || {};
      const partes = [endereco.morada, endereco.localidade, endereco.pais].filter(
        (parte) => parte && String(parte).trim() !== ""
      );
      return partes.length ? partes.join(", ") : "Não Atribuído";
    },
  },
  methods: {
    iconStyle() {
      return {
        color:
          this.form_data.status === "desativado"
            ? "var(--desativado)"
            : "var(--icon)",
        cursor: this.form_data.status === "desativado" ? "not-allowed" : "pointer",
      };
    },
    showConfirm(event, message) {
      this.emit_type = message;
      this.$refs.myConfirm.show(event.target);
    },
    onAccept() {
      if (this.emit_type == "create") {
        this.create();
      } else if (this.emit_type == "update") {
        this.update();
      } else if (this.emit_type == "disable") {
        this.$emit("disable", this.getFormData());
      } else if (this.emit_type == "remove") {
        this.$emit("remove", this.getFormData());
      } else {
        this.$emit("show_table", this.emit_type);
      }
    },
    selectTable(name) {
      this.$emit("show_table", name);
    },
    create() {
      if (!this.isValidForm()) return;
      this.$emit("create", this.getFormData());
    },
    update() {
      if (!this.isValidForm()) return;
      this.$emit("update", this.getFormData());
    },
    isValidForm() {
      if (!this.formData.sucursal || (this.set_data.zona?.id || 0) === 0) {
        toast("Preencha todos os campos obrigatórios!", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        ...this.formData,
        ...this.set_data,
      };
    },
    close() {
      this.$emit("close");
    },
  },
  watch: {
    form_data: {
      handler(newVal) {
        this.formData = { ...newVal };
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.form_container {
  display: flex;
  gap: 1px;
  padding: 1px;
  border-radius: 10px;
}

.left_form {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

h3 {
  display: flex;
  padding: 0.4rem;
  color: var(--label);
}

label {
  display: block;
  color: var(--label);
  font-size: 14px;
  padding: 0.2rem;
  min-width: 1rem;
  text-wrap: nowrap;
}

.btn {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: var(--button);
  color: var(--label);
  border: none;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  gap: 0.5rem;
}

.data_set_class {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px;
  border-radius: 10px;
  background-color: var(--fundoComponente);
}

.ser_data {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.ser_data label {
  min-width: 120px;
  text-align: left;
  font-weight: bold;
  color: var(--label);
}

.input-required {
  background-color: var(--obrigatorio);
}
</style>
